jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};
/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

 Shopify.Products = (function() {

   var config = {
     howManyToShow: 3,
     howManyToStoreInMemory: 10,
     wrapperId: 'recently-viewed-products',
     templateId: 'recently-viewed-product-template',
     onComplete: function(){
      var $rvDom = $('#recently-viewed-products-section');
      if( $rvDom.find('.swiper-slide').length === 0 ) return false;

      $rvDom.parent().removeClass('hide');

      var $rvInstant = $('#recently-viewed-products-section .swiper-container__recently-view');
      $rvInstant.addClass('swiper-container');
      var xs_item = $rvInstant.attr('data-xs');
      var sm_item = $rvInstant.attr('data-sm');
      var md_item = $rvInstant.attr('data-md');
      var lg_item = $rvInstant.attr('data-lg');
      var datarow = $rvInstant.attr('data-row');
      if (typeof xs_item !== typeof undefined && xs_item !== false) {
      } else{
        xs_item = 1;
      }

      if (typeof sm_item !== typeof undefined && sm_item !== false) {
      } else{
        sm_item = 2;
      }

      if (typeof md_item !== typeof undefined && md_item !== false) {
      } else{
        md_item = 3;
      }
      if (typeof lg_item !== typeof undefined && lg_item !== false) {
      } else{
        lg_item = 3;
      }
      if (typeof datarow !== typeof undefined && datarow !== false) {
      } else{
        datarow = 1;
      }
      var config = {
        spaceBetween: $rvInstant.data('margin'),
        slidesPerView: $rvInstant.data('items'),
        direction: 'horizontal',
        slidesPerColumn: datarow,
        paginationClickable: true,
        lazy: true,
        loop: true,
        uniqueNavElements: false,
        pagination: {
          el: $rvInstant.find('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: $rvInstant.parent().find('.swiper-button-next'),
          prevEl: $rvInstant.parent().find('.swiper-button-prev')
        },
        scrollbar: {
          el: $rvInstant.find('.swiper-scrollbar')
        },
        breakpoints: {
          300: {
            slidesPerView: 2
          },
          480: {
            slidesPerView: xs_item
          },
          640: {
            slidesPerView: sm_item
          },
          991: {
            slidesPerView: md_item
          },
          1199: {
            slidesPerView: lg_item
          }
        }
      };

      var swiper = new Swiper('#recently-viewed-products-section .swiper-container', config);
      $('#recently-viewed-products-section .widget-content').fadeIn();
      window.dispatchEvent(new Event('resize'));
     }
   };

   var productHandleQueue = [];
   var wrapper = null;
   var template = null;
   var shown = 0;

   var cookie = {
     configuration: {
       expires: 90,
       path: '/',
       domain: window.location.hostname
     },
     name: 'elecboy_rv',
     write: function(recentlyViewed) {
       jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
     },
     read: function() {
       var recentlyViewed = [];
       var cookieValue = jQuery.cookie(this.name);
       if (cookieValue !== null) {
         recentlyViewed = cookieValue.split(' ');
       }
       return recentlyViewed;
     },
     destroy: function() {
       jQuery.cookie(this.name, null, this.configuration);
     },
     remove: function(productHandle) {
       var recentlyViewed = this.read();
       var position = jQuery.inArray(productHandle, recentlyViewed);
       if (position !== -1) {
         recentlyViewed.splice(position, 1);
         this.write(recentlyViewed);
       }
     }
   };

  var finalize = function() {
    // If we have a callback.
    $(document).trigger('elecboy-ajax-products');
    if (config.onComplete) {
      try { config.onComplete() } catch (error) { }
    }
  };

  var moveAlong = function() {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      if (productHandleQueue[0]=="") {
        productHandleQueue.shift();
        moveAlong();
      } else {
        jQuery.ajax({
          //dataType: 'json',
          url: '/products/' + productHandleQueue[0] + '?view=product-brick',
          cache: false,
          success: function(product) {
            if ( product.indexOf('view: product.product-brick')!=-1 ) {
              // only append product-brick view
              wrapper.append("<div class='swiper-slide'>"+product+"</div>");
              shown++;
            }
            productHandleQueue.shift();
            moveAlong();
           },
          error: function() {
            cookie.remove(productHandleQueue[0]);
            productHandleQueue.shift();
            moveAlong();
           }
         });
      }
    } else {
      finalize();
    }

   };

   var getProductHandle = function() {
    return $('.product-single').data('product-handle') || $('.pdp-template').data('product-handle');
   };

   return {

     resizeImage: function(src, size) {
       if (size == null) {
         return src;
       }

       if (size == 'master') {
         return src.replace(/http(s)?:/, "");
       }

       var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

       if (match != null) {
         var prefix = src.split(match[0]);
         var suffix = match[0];

         return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
       } else {
         return null;
       }
     },

     showRecentlyViewed: function(params) {
       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read();

       // Template and element where to insert.
       wrapper = jQuery('#' + config.wrapperId);

       // How many products to show.
       config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

       // If we have any to show.
       if (config.howManyToShow && wrapper.length) {
         // Getting each product with an Ajax call and rendering it on the page.
         moveAlong();
       } else {
        $(document).trigger('elecboy-ajax-products');
       }

     },

     getConfig: function() {
       return config;
     },

     clearList: function() {
       cookie.destroy();
     },

     recordRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       var recentlyViewed = cookie.read();

       // If we are on a product page.
       if (window.location.pathname.indexOf('/products/') !== -1) {

         // What is the product handle on this page.
         //var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
         var productHandle = getProductHandle();
         if (productHandle == "") return false;
         // In what position is that product in memory.
         var position = jQuery.inArray(productHandle, recentlyViewed);
         // If not in memory.
         if (position === -1) {
           // Add product at the start of the list.
           recentlyViewed.unshift(productHandle);
           // Only keep what we need.
           recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
         }
         else {
           // Remove the product and place it at start of list.
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);
         }

         // Update cookie.
         cookie.write(recentlyViewed);

       }

     }

  };
})();

$(document).ready(function(){
  if ( $('.template-product').length == 1 ){
    // if it is PDP page, record product view
    Shopify.Products.recordRecentlyViewed();
  }
  if( $('#recently-viewed-products-section').length ) {
    Shopify.Products.showRecentlyViewed( { howManyToShow:6 } );
  } else {
    $(document).trigger('elecboy-ajax-products');
  }
});

